import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import css from './GoToReachMeeProfile.module.scss';
import Button from 'components/Button';
import LinkButton from '../Models/LinkButton/LinkButton';

import { THEMES, getThemeClassNames } from 'constants/themes';

class GoToReachMeeProfile extends React.PureComponent {
    static propTypes = {
        text: PropTypes.string,
        button1: PropTypes.shape(LinkButton.propTypes),
        button2: PropTypes.shape(LinkButton.propTypes),
        theme: PropTypes.oneOf(Object.keys(THEMES).map(s => THEMES[s]))
    }

    render() {
        const {
            text,
            button1,
            button2,
            theme
        } = this.props;
        
        return (
            <div className={cn(css.block, getThemeClassNames(css, theme))} data-epi-property-name='GoToReachmeeProfile'>
                <div className={css.content}>
                    <p className={css.text}>{text}</p>
                    {button1 && <Button href={button1.url} target={button1.target} className={css.button}>{button1.text}</Button>}
                    {button2 && <Button href={button2.url} target={button2.target} className={css.button}>{button2.text}</Button>}
                </div>
            </div>
        );
    }
}

export default GoToReachMeeProfile;


// WEBPACK FOOTER //
// ./src/components/GoToReachMeeProfile/GoToReachMeeProfile.jsx